
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, blogCategories } from '../../../mocks/blogPosts';

export default function BlogGrid() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All'
    ? blogPosts
    : blogPosts.filter((p) => p.category === activeCategory);

  return (
    <section className="py-20 bg-[#F9FBF7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-10">
          <h4 className="text-2xl font-serif text-gray-900">
            <a href="/blog">Latest Articles</a>
          </h4>
          <div className="flex items-center gap-1 bg-white rounded-full p-1 shadow-sm border border-gray-100">
            {blogCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-xs font-medium tracking-wide transition-all cursor-pointer whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-[#2E7D32] text-white'
                    : 'text-gray-600 hover:text-[#2E7D32] hover:bg-[#E8F5E9]'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-16">
            <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
              <i className="ri-article-line text-2xl text-gray-400"></i>
            </div>
            <p className="text-gray-500 text-sm">No articles in this category yet.</p>
          </div>
        ) : (
          <div className="grid grid-cols-3 gap-8">
            {filtered.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.id}`}
                className="group cursor-pointer block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-50"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    title={`${post.title} - Daliah Secret`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-3 py-1 bg-white/90 backdrop-blur-sm text-[#2E7D32] text-[10px] font-semibold rounded-full tracking-wider">
                    {post.category}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-serif text-gray-900 mb-2 leading-snug group-hover:text-[#2E7D32] transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-500 text-sm mb-4 line-clamp-2 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded-full bg-[#E8F5E9] flex items-center justify-center">
                        <i className="ri-user-line text-[#2E7D32] text-xs"></i>
                      </div>
                      <div>
                        <p className="text-xs font-medium text-gray-800">{post.author}</p>
                        <p className="text-[10px] text-gray-400">{post.date}</p>
                      </div>
                    </div>
                    <span className="text-[10px] text-gray-400 tracking-wide">{post.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
